import React from "react";
import { useInView } from "react-intersection-observer";
const Roadmap = () => {
  const [ref, inView] = useInView({
    triggerOnce: false, // Only trigger once when the element comes into view
  });
  return (
    <>
      <section
        id="tokenomics"
        ref={ref}
        className={`RoadmapSection ${inView ? "showcontent" : ""}`}
      >
        <div className="container" id="roadmap">
          <div className="row">
            <div className="col-12">
              <div className="Roadmap">
                <div className="image">
                  <img src="/images/roadmapback.png" />
                </div>
                <div className="roadmap-content">
                  <div className="heading">
                    <h4>Roadmap</h4>
                    <p style={{ maxWidth: "768px" }}>
                    Are You A Strategic Partner? Because Just Like Our Roadmap, 
                    I See A Future Of Growth And Expansion Together,
                    Starting With A Token Launch And Ending With A Legacy Worth Sharing!
                    </p>
                  </div>
                  <ul className="timeline list-inline">
                    <li
                      className="q1"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 1</h4>
                      <p>
                      Licensing, token pre-registration, global marketing, token launch, 
                      fundraising platform,
                      valuation and source strategic partners for our pilot projects.
                      </p>
                    </li>
                    <li
                      className="q2"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 2:</h4>
                      <p>
                      Advanced Layer 1 Blockchain deployment and decentralized wallet launch.
                      </p>
                    </li>
                    <li
                      className="q3"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 3:</h4>
                      <p>
                      RWA and Legacy Tokenization platforms, AI fund management and market expansion.
                      </p>
                    </li>
                    <li
                      className="q4"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 4:</h4>
                      <p>
                      Deployment and Public Relations Announcements: Launching the platform to the public and generating buzz through strategic PR campaigns.
                      </p>
                    </li>
                    {/* <li
                      className="q5"
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <h4>Phase 5:</h4>
                      <p>
                        Introduce Social Metaverse
                      </p>

                      <p>
                        Implement cooperate sports & fitness partnership.
                      </p>

                      <p>
                        Add Additional Utilities.
                      </p>
                      
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Roadmap;
